import script from "./DiscountForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiscountForm.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__